import {
  setClassesMeta,
  setDataOnlineClasses,
  setDetailWellnessClass,
} from "../reducers/wellnesseventsReducer";

import axios from "../api/HttpService";

const API_URL = process.env.REACT_APP_API_URL;

export const getOnlineClasses = async (dispatch, id, selectedClassId = null, retireeId = null) => {
  try {
    const effectiveId = id || retireeId;
    if (!effectiveId) return;
    // If id is a number, return. Location id should be at least 5 characters long
    if (typeof effectiveId === 'number') {
      return;
    }
    if (effectiveId && effectiveId.length < 5) return; // If the id is not valid, return. Location id should be at least 5 characters long
    
    let endpoint = `api/classes/get-online-classes/${effectiveId}`;
    if (retireeId && !id) {
      endpoint = `api/retiree/${retireeId}/classes`;
    }
    
    const online = await axios.get(API_URL + endpoint);
    dispatch(setDataOnlineClasses({ classes: online.data.data }));
    dispatch(setClassesMeta({ wellnessClassesMeta: online.data.meta }));
    if (selectedClassId) {
      const selectedClass = online.data.data.find((c) => c.ID === selectedClassId);
      dispatch(setDetailWellnessClass({ wellnessClassSelected: selectedClass }));
    }
  } catch (error) {}
};
